import * as _ from "lodash-es";

/**
 * @type {{status_label: String, application_status: Number, is_status_enabled: bool}[]}
 */
const APPLICATION_STATUS_SETTINGS =
  // The first check is for jest tests.
  // The second one is for browsers which page wasn't refreshed yet.
  (window.SchoolSettings && window.SchoolSettings.application_status_settings) || [];
const APPLICATION_STATUS_POSITION_MAP = _.fromPairs(
  APPLICATION_STATUS_SETTINGS.map((settings, index) => [
    settings.application_status,
    index,
  ]),
);
const ENABLED_APPLICATION_STATUS_SETTINGS = APPLICATION_STATUS_SETTINGS.filter(
  (settings) => settings.is_status_enabled,
);
const STATUSES = {
  REGISTER_INTEREST: -1,
  ENQUIRY: 0,
  EVENT_BOOKING: 1,
  GPA: 2,
  ENROLMENT: 3,
  ORIENTATION: 4,
  COMMUNITY: 5,
  ALUMNUS: 6,
  ARCHIVE: 7,
  DECLINED: 8,
  WAITLIST: 9,
  RESERVED_PLACE: 10,
  NOT_PROCEEDING: 11,
  ENROLMENT_OFFER: 12,
  INTERVIEW: 13,
  PENDING: 14,
  CUSTOM_1: 15,
  CUSTOM_2: 16,
  CUSTOM_3: 17,
};
const INOPERATIVE_STATUSES = [
  STATUSES.ARCHIVE,
  STATUSES.DECLINED,
  STATUSES.NOT_PROCEEDING,
];
const NON_PROSPECTIVE_SATUSES = [
  ...INOPERATIVE_STATUSES,
  STATUSES.COMMUNITY,
  STATUSES.ALUMNUS,
];

export default {
  ...STATUSES,
  INOPERATIVE: INOPERATIVE_STATUSES,
  NON_PROSPECTIVE: NON_PROSPECTIVE_SATUSES,
  FOR_PREDICTOR_REPORT: [STATUSES.PENDING, STATUSES.WAITLIST, STATUSES.RESERVED_PLACE],
  ENABLED: ENABLED_APPLICATION_STATUS_SETTINGS,
  statusesMap: _.keyBy(APPLICATION_STATUS_SETTINGS, "application_status"),
  options: ENABLED_APPLICATION_STATUS_SETTINGS.map((settings) => ({
    value: settings.application_status,
    text: settings.status_label,
  })),
  statusSettings: APPLICATION_STATUS_SETTINGS,

  getStatusLabel(status) {
    // TODO: grep `The check is for jest tests` and check if they are required.
    // The check is for jest tests
    return this.statusesMap[status] ? this.statusesMap[status].status_label : "";
  },
  getStatusPosition(status) {
    return APPLICATION_STATUS_POSITION_MAP[status];
  },
  isStatusEnabled(status) {
    // The check is for jest tests
    return this.statusesMap[status] ? this.statusesMap[status].is_status_enabled : false;
  },
  /**
   * Check if any status is enabled.
   * @param {Number[]} statuses
   * @returns {Boolean}
   */
  isAnyStatusEnabled(statuses) {
    return statuses.some((status) => this.isStatusEnabled(status));
  },
  /** Check if the status is achieved according to the enrolment journey stages. */
  isStatusAchieved(statusToCheck, targetStatus) {
    return this.getStatusPosition(statusToCheck) >= this.getStatusPosition(targetStatus);
  },
  isParentDashboardEnrolmentProcessEnabled() {
    return this.statusSettings.some((s) =>
      this.isParentDashboardStageVisible(s.application_status),
    );
  },
  isParentDashboardStageVisible(status) {
    return (
      this.isStatusEnabled(status) &&
      (this.statusesMap[status]
        ? this.statusesMap[status].is_parent_dashboard_stage_visible
        : false)
    );
  },
};
